import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ModalComponent2 } from './modal/modal.component';
import { PipesModule } from '../../shared/pipes/pipes.module';
import { DirectivesModule } from '@sc/portal.fe.lib.ui-core-components';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ModalService } from './modal/modal.service';
import { MainSideBarComponent } from './main-side-bar/main-side-bar.component';
import { SnackBarComponent } from './snack-bar/snack-bar.component';
import { ButtonComponent } from './button/button.component';
import { TabsComponent } from './tabs/tabs.component';
import { ExternalUrlComponent } from './external-url/external-url.component';
import { MainSideBarService } from 'app/components/shared/main-side-bar/main-side-bar.service';
import { ListSetService } from 'app/core/services/list-set.service';
import { IconModule, ScTabModule,ButtonModule } from '@sc/portal.fe.lib.ui-core-components';
import { NotificationComponent } from './notification/notification.component';
import { RouterModule } from '@angular/router';
import { NotificationTypeActionComponent } from './notification/notification-type-action/notification-type-action.component';
import { CloseModalModule } from '@sc/pas-common-ui';
import { PolicyCancellationDetailsComponent } from './notification/policy-cancellation-details/policy-cancellation-details.component';

const components = [
    ModalComponent2,
    MainSideBarComponent,
    SnackBarComponent,
    ButtonComponent,
    TabsComponent,
    ExternalUrlComponent,
    NotificationComponent,
    NotificationTypeActionComponent,
    PolicyCancellationDetailsComponent
     
];

@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        BrowserAnimationsModule,
        FormsModule,
        PipesModule,
        DirectivesModule,
        IconModule,
        CloseModalModule,
        RouterModule,
        ScTabModule,
        ButtonModule 
                        
    ],
    declarations: components,
    exports: components,
    providers: [
        ModalService,
        MainSideBarService,
        ListSetService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedComponentsModule {
}
